/* eslint-disable no-console */
import { format } from 'date-fns';
import {
  BUILD_DATE,
  BUILD_VERSION,
  PLATFORM_VERSION,
} from 'layout/Header/About';
import Logger from './Logger';

export function intro() {
  const INTRO = `%c ----------------------------------------------------------------------------------------- 
|                                                                                         |
|                             (        )     (                                            |
|   (    (              (     )\\ )  ( /(     )\\ )  (           )  (                       |
|   )\\   )\\        (    )\\ ) (()/(  )\\())   (()/(  )\\    )  ( /(  )\\ )       (       )    |
| (((_) ((_) (    ))\\  (()/(  /(_))((_)\\     /(_))((_)( /(  )\\())(()/(   (   )(     (     |
| )\\___  _   )\\  /((_)  ((_))(_))    ((_)   (_))   _  )(_))(_))/  /(_))  )\\ (()\\    )\\  ' |
|((/ __|| | ((_)(_))(   _| | |_ _|  / _ \\   | _ \\ | |((_)_ | |_  (_) _| ((_) ((_) _((_))  |
| | (__ | |/ _ \\| || |/ _\` |  | |  | (_) |  |  _/ | |/ _\` ||  _|  |  _|/ _ \\| '_|| '  \\() |
|  \\___||_|\\___/ \\_,_|\\__,_| |___|  \\___/   |_|   |_|\\__,_| \\__|  |_|  \\___/|_|  |_|_|_|  |
|                                                                                         |
| :: ${`CloudIO Platform ${PLATFORM_VERSION} | ${BUILD_VERSION} | ${format(
    new Date(BUILD_DATE),
    'dd-MMM-yyyy',
  )} `.padEnd(81, ' ')} :: |
 ----------------------------------------------------------------------------------------- 
`;
  if (console) {
    console.log(
      INTRO,
      'color: #fff; background-color: #157CEC; white-space: pre;',
    );
  }
  Logger.log({
    itemType: 'CloudIO',
    msg: `\n${INTRO}`,
    status: 'info',
    onRender: true,
  });
}
